export enum AddMediaSideBarActionsTarget {
  Opened = 'opened',
  Closed = 'closed',
  CancelAll = 'cancel_all',
  RetryList = 'retry_list',
  Retry = 'retry',
  Resume = 'resume',
  ClearList = 'clear_list',
  ForceClearList = 'force_clear_list',
  Clear = 'clear',
  GoToFile = 'go_to_file',
  EditTags = 'edit_tags',
}

export interface IWithTrackAddMediaSideBarActionsAnalyticsInner {
  trackAddMediaSideBarActionOpened: () => void;
  trackAddMediaSideBarActionClosed: () => void;
  trackAddMediaSideBarActionCancelAll: () => void;
  trackAddMediaSideBarActionRetryList: () => void;
  trackAddMediaSideBarActionRetry: () => void;
  trackAddMediaSideBarActionClearList: () => void;
  trackAddMediaSideBarActionForceClearList: () => void;
  trackAddMediaSideBarActionClear: () => void;
  trackAddMediaSideBarActionGoToFile: () => void;
  trackAddMediaSideBarActionEditTags: () => void;
}

export interface IWithTrackAddMediaSideBarActionsAnalyticsOuter {}
